// extracted by mini-css-extract-plugin
export default {"Brands":"Brands_Brands__nayjO"};